import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import api from "@/lib/api";

export default function MessagesIndicator() {
  const [unread, setUnread] = useState(0);

  const load = async () => {
    try {
      const { data } = await api.get("/messages/inbox/unread");
      setUnread(data.unread || 0);
    } catch { /* ignore */ }
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 60_000);
    return () => clearInterval(t);
  }, []);

  return (
    <Link
      to="/comunicacion"
      data-testid="topbar-messages-link"
      className="relative h-10 w-10 rounded-full flex items-center justify-center hover:bg-black/[0.05] dark:hover:bg-white/[0.06] transition-colors"
      aria-label="Comunicación interna"
    >
      <Mail className="h-5 w-5 text-[var(--legatum-text-secondary)]" />
      {unread > 0 && (
        <span
          data-testid="messages-badge"
          className="absolute top-1.5 right-1.5 min-w-[18px] h-[18px] px-1 rounded-full bg-[var(--legatum-accent)] text-[var(--legatum-accent-fg)] text-[10px] font-bold flex items-center justify-center border-2 border-[var(--legatum-bg)] tabular-nums"
        >
          {unread > 99 ? "99+" : unread}
        </span>
      )}
    </Link>
  );
}
